import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

import styled from 'styled-components';

import { getCommunityBrochureAndDocs } from 'apis/CommunityAPI';
import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';
import { ALL_FILTER_OPTION } from 'components/lib/constants';
import PillSwitcher from 'components/lib/PillSwitcher';
import { DOCUMENTS_FIELD, DOCUMENTS_FIELDS_LABEL, FIELD_CATEGORY } from 'components/ShopData/constants';

import BrochureAndDocsContent from './BrochureAndDocsContent';
import { brochureAndDocsQueryKey } from './constants';
import { buildDocumentTabs, filterFilesByTab, getFileGroups, sortFilesByNewest } from './helpers';
import { FILE_SOURCE } from '../../../../constants';
import Header from '../../common/header/Header';

const Container = styled.div`
  position: relative;
`;

const NoDataLabel = styled.div`
  color: var(--text-secondary);
`;

const Tabs = styled(PillSwitcher)`
  margin-top: 15px;
`;

const HistoryButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 1;
  color: var(--deep-blue);
  width: 60px;
  height: 28px;
  background-color: var(--lighter-gray);
  border-radius: 4px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

const BrochureAndDocs = () => {
  const { setHistory } = useCommunityInfoContext();
  const [brochureAndDocs, setBrochureAndDocs] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState<string>(ALL_FILTER_OPTION.value);

  const { competitorId } = useParams();
  const { communityId } = useParams();
  const id = Number(competitorId || communityId);

  useQuery({
    queryKey: brochureAndDocsQueryKey(id),
    queryFn: () =>
      getCommunityBrochureAndDocs(id, {
        source: [FILE_SOURCE.MEDIA],
        latest_per_category: true,
      }),

    onSuccess: (data) => {
      setBrochureAndDocs(data ?? []);
    },

    enabled: Boolean(id),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  const groups = getFileGroups(brochureAndDocs);

  const tabs = buildDocumentTabs(groups);

  const filteredDocuments = sortFilesByNewest(filterFilesByTab(brochureAndDocs, selectedTab));

  const handleViewHistory = () => {
    setHistory({
      category: FIELD_CATEGORY.DOCUMENTS,
      field: DOCUMENTS_FIELD,
      label: DOCUMENTS_FIELDS_LABEL,
      documentTab: selectedTab,
    });
  };

  return (
    <Container>
      <Header
        title="Brochures & Documents"
        controls={<HistoryButton onClick={handleViewHistory}>History</HistoryButton>}
      />
      {tabs.length > 1 && <Tabs items={tabs} activeKey={selectedTab} onChange={(key) => setSelectedTab(String(key))} />}
      <BrochureAndDocsContent data={filteredDocuments} showDate />
      {filteredDocuments.length === 0 && <NoDataLabel>There is nothing here.</NoDataLabel>}
    </Container>
  );
};

export default BrochureAndDocs;
